import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonIcon, IonLabel, IonList, IonMenuToggle, IonToolbar } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { LangSelectComponent } from '@okcargo-apps/shared-application-ionic';
@Component({
  selector: 'app-menu-footer',
  templateUrl: './menu-footer.component.html',
  styleUrls: ['./menu-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    IonToolbar,
    IonList,
    IonMenuToggle,
    IonIcon,
    IonLabel,
    LangSelectComponent,
  ],
})
export class MenuFooterComponent {}
